import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { ButtonBase, Card, Grid } from '@mui/material'
import { Box } from '@mui/system'
import { useGetScreenHoldingCollections } from '../../APIs/Hooks/ScreenHoldingCollectionHooks'
import ScreenCollectionDetails from './ScreenCollection/ScreenCollectionDetails'
import { tsScreenCollection } from '../../Typescript/DB_Interface'
import PageSection from '../../Constants&Theme/PageSection'

function ScreenHolding() {
  const navigate = useNavigate()
  const { holding_id } = useParams()
  const { data: screenCollections } = useGetScreenHoldingCollections(holding_id)
  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={`${screenCollections?.ScreenName}: Collections`}>
        <Grid
          container
          spacing={3}
        >
          {screenCollections?.Collections &&
            screenCollections?.Collections.map((item: tsScreenCollection) => (
              <Grid
                item
                xs={12}
                key={item.ScreenCollectionID}
              >
                <ButtonBase
                  onClick={() => {
                    navigate(
                      '/stuart/health/collections/' + item.ScreenCollectionID,
                    )
                  }}
                  sx={{ width: 1 }}
                >
                  <Card
                    elevation={4}
                    sx={{ width: 1, p: 2 }}
                  >
                    <ScreenCollectionDetails collection={item} />
                  </Card>
                </ButtonBase>
              </Grid>
            ))}
        </Grid>
      </PageSection>
    </Box>
  )
}

export default ScreenHolding
